import { restrictions } from 'state/features-list/constants';
import { isFeatureEnabled } from 'stores/features-list-store';
import { LEAGUE_MODULE_NAMES, getModulePath } from '@leagueplatform/core';
import USER_ROLES from 'constants/user-roles.constant';
import { HealthJourneyRoutes } from '@leagueplatform/health-journey';

const commonModuleData = {
  restrictions: {
    user: [restrictions.care_pathways],
  },
  data: {
    title: 'components.main_menu.care_path',
    section: 'myCare',
    mainMenu: 'myCare',
    hideFooter: true,
    authorizedRoles: [USER_ROLES.employee],
    includeInMenu: false,
  },
};

const leagueModule = {
  healthJourney: {
    name: LEAGUE_MODULE_NAMES.healthJourney,
    url: `${getModulePath(LEAGUE_MODULE_NAMES.healthJourney)}/*`,
    element: <HealthJourneyRoutes />,
    restrictions: {
      user: [restrictions.care_pathways],
    },
    data: {
      title: 'components.main_menu.care_path',
      section: 'myCare',
      mainMenu: 'myCare',
      checkIncludeInMenu: () => {
        return (
          !isFeatureEnabled(restrictions.care_plans) &&
          !isFeatureEnabled(restrictions.tmh_engagement_and_reporting) &&
          isFeatureEnabled(restrictions.care_pathways)
        );
      },
      hideFooter: true,
      authorizedRoles: [USER_ROLES.employee],
    },
  },
  healthProgress: {
    name: LEAGUE_MODULE_NAMES.healthProgress,
    url: `${getModulePath(LEAGUE_MODULE_NAMES.healthProgress)}/*`,
    resolver: () =>
      Promise.all([
        import(
          /* webpackChunkName: "league-health-journey" */ '@leagueplatform/health-journey'
        ),
      ]).then(([component]) => {
        return { default: component.HealthJourneyRoutes };
      }),
    ...commonModuleData,
  },
  healthPrograms: {
    name: LEAGUE_MODULE_NAMES.healthPrograms,
    url: `${getModulePath(LEAGUE_MODULE_NAMES.healthPrograms)}/*`,
    resolver: () =>
      Promise.all([
        import(
          /* webpackChunkName: "league-health-journey" */ '@leagueplatform/health-journey'
        ),
      ]).then(([component]) => {
        return { default: component.HealthJourneyRoutes };
      }),
    ...commonModuleData,
  },
  healthJourneyHistory: {
    name: LEAGUE_MODULE_NAMES.healthJourneyHistory,
    url: `${getModulePath(LEAGUE_MODULE_NAMES.healthJourneyHistory)}/*`,
    resolver: () =>
      Promise.all([
        import(
          /* webpackChunkName: "league-health-journey" */ '@leagueplatform/health-journey'
        ),
      ]).then(([component]) => {
        return { default: component.HealthJourneyRoutes };
      }),
    ...commonModuleData,
  },
  programHistory: {
    name: `${LEAGUE_MODULE_NAMES.program}-history`,
    url: `${getModulePath(LEAGUE_MODULE_NAMES.program)}/history/*`,
    resolver: () =>
      Promise.all([
        import(
          /* webpackChunkName: "league-health-journey" */ '@leagueplatform/health-journey'
        ),
      ]).then(([component]) => {
        return { default: component.ProgramOverviewHistoryPage };
      }),
    ...commonModuleData,
  },
  program: {
    name: LEAGUE_MODULE_NAMES.program,
    url: `${getModulePath(LEAGUE_MODULE_NAMES.program)}/*`,
    resolver: () =>
      Promise.all([
        import(
          /* webpackChunkName: "league-health-journey" */ '@leagueplatform/health-journey'
        ),
      ]).then(([component]) => {
        return { default: component.ProgramOverviewPage };
      }),
    ...commonModuleData,
  },
  healthJourneyActivitiesList: {
    name: `${LEAGUE_MODULE_NAMES.healthJourney}-activities-list`,
    url: `${getModulePath(LEAGUE_MODULE_NAMES.healthJourney)}/activities-list/*`,
    resolver: () =>
      Promise.all([
        import(
          /* webpackChunkName: "league-health-journey" */ '@leagueplatform/health-journey'
        ),
      ]).then(([component]) => {
        return { default: component.ViewAllPageWrapper };
      }),
    ...commonModuleData,
  },
  careLibrary: {
    name: LEAGUE_MODULE_NAMES.careLibrary,
    url: `${getModulePath(LEAGUE_MODULE_NAMES.careLibrary)}/*`,
    resolver: () =>
      Promise.all([
        import(
          /* webpackChunkName: "league-health-journey" */ '@leagueplatform/health-journey'
        ),
      ]).then(([component]) => {
        return { default: component.HealthJourneyRoutes };
      }),
    ...commonModuleData,
  },
};

export default leagueModule;
